import {createTemplate} from "@helpers/create-template.js";
import {snakeToCamel} from "@helpers/string-helper";
import 'mapbox-gl/dist/mapbox-gl.css'
import mapboxgl from 'mapbox-gl'
import type {Point} from "geojson";


const template: HTMLTemplateElement | null = createTemplate(`
    <template>    
        <div id="map-wrapper" class="h-full w-full relative -mt-[76px] md:-mt-[88px]">
            <div id="map" class="h-full w-full"></div>
        </div>
    </template>
`);


export default class Mapbox extends HTMLElement {
    private apiurl : string;
    private house: string;
    private houseactive: string;
    private borders: string;
    private map;
    private popup;
    private hoverMarker;
    private features = [];
    private categoryId = "";
    private houseId = "";

    /**
     * Props
     * Add all attributes ot you web component.
     * For attributeChangedCallback() callback to fire when an attribute changes, you have to observe the attributes.
     */
    static get observedAttributes() {
        return ['apiurl', 'house', 'houseactive', 'borders']
    }

    constructor() {
        super();
        this.appendChild(template.content.cloneNode(true));
    }

    // The browser calls this method when the element is
    // added to the DOM.
    connectedCallback() {
        this.initializeComponent();
    }

    // then will attibuteChangedCallback will be calles
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            for (const item of Mapbox.observedAttributes) {
                if (item === name) {
                    const propertyName : string = snakeToCamel(item) as string
                    this[propertyName] = newValue //Set text in property
                }
            }
        }
        this.updateTextsfromAttributes()
    }

    /**
     * Sets texts of tags with a data-attribute with webcomponents attribute value
     */
    updateTextsfromAttributes() {
        Mapbox.observedAttributes.forEach((item) => {
            const propertyName : string = snakeToCamel(item) as string
            const selector = '[data-attribute=' + item + ']'
            this.querySelectorAll(selector).forEach((item) => {
                item.innerHTML = this[propertyName] //Get text from property and write to HTML
            })
        })
    }

    initializeComponent() {
        this.apiurl = this['apiurl']
        this.house = this['house']
        this.houseactive = this['houseactive']
        this.borders = this['borders']
        this.loadMap()
        this.loadFilter();
    }

    loadFilter() {


        const input = document.getElementById('search-field');
        input.addEventListener("keyup", this.filterList)

        document.querySelectorAll('#filter-houses li').forEach((item) => {
            const houseId = item.getAttribute('data-id');
            this.categoryId = "";

            if (houseId === this.houseId) {
                item.classList.add("filter-active")
            }
            item.addEventListener("click", () => {
                if (this.hoverMarker) {
                    this.hoverMarker.setLngLat([0,0]);
                }
                if (this.popup) {
                    this.popup.remove();
                }
                if (window.innerWidth <= 768) {
                    document.querySelector('#filter-houses').classList.remove("active");
                }

                this.houseId = item.getAttribute('data-id');

                document.querySelectorAll('.filter-active').forEach((item) => {
                    item.classList.remove("filter-active");
                });

                document.querySelector("*[data-category='']").classList.add("filter-active");

                let filteredFeatures = [];
                if (houseId) {
                    filteredFeatures = this.features.filter(item => item.id == this.houseId)
                } else {
                    filteredFeatures = this.features;
                }

                item.classList.add("filter-active")
                this.map.getSource("features").setData(
                    {
                        type: "FeatureCollection",
                        features: filteredFeatures
                    }
                );
            })
        })

        document.querySelectorAll('.filter-btn').forEach((item) => {
            const categoryId = item.getAttribute('data-category');
            if (categoryId === this.categoryId) {
                item.classList.add("filter-active")
            }
            item.addEventListener('click', () => {
                if (this.hoverMarker) {
                    this.hoverMarker.setLngLat([0,0]);
                }
                if (this.popup) {
                    this.popup.remove();
                }

                document.querySelectorAll('.filter-active').forEach((item) => {
                    item.classList.remove("filter-active");
                });

                this.categoryId = item.getAttribute('data-category');
                const houseFilter = document.querySelector('#filter-houses');
                let filteredFeatures = [];
                if (categoryId) {
                    filteredFeatures = this.features.filter(item => item.properties.categories.find(cat => cat.id == this.categoryId))
                    houseFilter.classList.remove("active");
                } else {
                    filteredFeatures = this.features;
                    houseFilter.classList.toggle("active");

                    filterBody.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
                item.classList.toggle("active", houseFilter.classList.contains("active"));

                item.classList.add("filter-active")
                this.map.getSource("features").setData(
                    {
                        type: "FeatureCollection",
                        features: filteredFeatures
                    }
                );
            })
        })
        const rightArrow = document.querySelector('.filter-arrow-right') as HTMLElement;
        const leftArrow = document.querySelector('.filter-arrow-left') as HTMLElement;
        const filterBody = document.querySelector('.filter-body');
        let prePosition = 0;

        filterBody?.addEventListener('scroll', () => {
            const scrollWidth = filterBody.scrollWidth;
            const clientWidth = filterBody.clientWidth;
            const scrollLeft = filterBody.scrollLeft;
            if (scrollLeft + clientWidth + 28 >= scrollWidth) {
                rightArrow.style.opacity = '0';
            } else {
                rightArrow.style.opacity = '1';
            }

            if (scrollLeft <=  150) {
                leftArrow.style.opacity = '0';
            } else {
                leftArrow.style.opacity = '1';
            }

            if (scrollLeft > prePosition) {
                document.querySelector('#filter-houses')?.classList.remove("active");
                document.querySelector('.filter-btn.filter-active')?.classList.remove("active");
            }
            prePosition = scrollLeft;
        });

        rightArrow.addEventListener("click", () => {
            filterBody.scrollBy({
                top: 0,
                left: 150,
                behavior: 'smooth'
            });
        })

        leftArrow.addEventListener("click", () => {
            filterBody.scrollBy({
                top: 0,
                left: -150,
                behavior: 'smooth'
            });
        })

        this.toggleArrow(filterBody, rightArrow, leftArrow);
        window.addEventListener("resize", () => {
            this.toggleArrow(filterBody, rightArrow, leftArrow);
        })
    }

    toggleArrow(element, arrowRight, arrowLeft) {
        if (element.scrollWidth > element.clientWidth) {
            arrowRight.style.opacity = 1;
        } else {
            arrowRight.style.opacity = 0;
            arrowLeft.style.opacity = 0;
        }

        if (element.scrollLeft <= 150 || element.scrollWidth <= element.clientWidth) {
            arrowLeft.style.opacity = '0';
        } else {
            arrowLeft.style.opacity = '1';
        }

        arrowRight.style.height = element.clientHeight + "px";
        arrowLeft.style.height = element.clientHeight + "px";
    }

    loadMap() {
        const defaultInitialViewState = {
            latitude: 47.45230512417123,
            longitude: 7.652047861780223,
            zoom: 11,
            interceptSearch: ''
        }
        const initialViewState = {
            latitude: defaultInitialViewState.latitude,
            longitude: defaultInitialViewState.longitude,
            zoom: defaultInitialViewState.zoom,
            interceptSearch: defaultInitialViewState.interceptSearch
        }

        mapboxgl.accessToken = 'pk.eyJ1IjoiY3VyYXZpdmFiYXNlbGxhbmQiLCJhIjoiY20xNjVoYmg4MGRocjJuc2NtNHM3a2x1dSJ9.ZNiiwrGoWwE-NEYNE9Q3NQ';

        this.map = new mapboxgl.Map({
            cooperativeGestures: true,
            container: 'map', // container ID
            style: "mapbox://styles/mapbox/light-v11",
            center: [initialViewState.longitude, initialViewState.latitude], // starting position [lng, lat]
            zoom: initialViewState.zoom, // starting zoom
            maxZoom: 17,
            minZoom: 9
        });

        this.map.on('load', async () => {
            this.map.addSource('borders', {
                type: 'geojson',
                data: this.borders
            });


            this.map.addLayer({
                'id': 'borders',
                'type': 'fill',
                'source': 'borders',
                'layout': {},
                'paint': {
                    'fill-color': 'rgba(90,180,70,0.6)',
                    'fill-opacity': .6
                }
            });
            this.map.fitBounds([
                [ 7.4373300890351475, 47.37075191727716] ,
                [7.938949956915836, 47.602660083831665]
            ], {padding: 50,maxZoom: 16});
            this.map.loadImage(
                this.house,
                (error, image) => {
                    if (error) {
                        this.map.addLayer({
                            id: "features",
                            type: "circle",
                            source: "features",
                            paint: {
                                "circle-radius": 9,
                                "circle-color": "#000000"
                            },
                        })

                        throw error;
                    }

                    this.map.addImage("house", image);

                    this.fetchFeatures().then((data) => {
                        this.features = data;
                        this.map.addSource("features",
                            {
                                type: "geojson",
                                data: {
                                    type: "FeatureCollection",
                                    features: data
                                }
                            });

                        this.map.addLayer({
                            id: "features",
                            type: "symbol",
                            source: "features",
                            layout: {
                                "icon-image": "house",
                                "icon-size": window.innerWidth > 789 ? 1 : 0.5,
                                "icon-allow-overlap": true,
                                "icon-ignore-placement": true,
                            }
                        })

                        const hoverMarkerElement = document.createElement('div');
                        hoverMarkerElement.className = 'marker';
                        hoverMarkerElement.innerHTML =
                            '<svg width="30" height="45" viewBox="0 0 30 45" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                            '  <rect y="15" width="30" height="30" fill="black"/>' +
                            '  <path d="M-2.52114e-06 15L15 0L30 15L-2.52114e-06 15Z" fill="black"/>' +
                            '</svg>'

                        this.hoverMarker = new mapboxgl.Marker(hoverMarkerElement).setLngLat([0,0]).addTo(this.map);

                        this.map.on('mouseenter', 'features', (e) => {
                            const features = this.map.queryRenderedFeatures(e.point, {
                                layers: ['features']
                            });

                            if (features.length && window.innerWidth > 768)  {
                                const feature = features[0];

                                const coords = feature.geometry.coordinates;
                                this.hoverMarker.setLngLat(coords);
                            }
                        });
                    }
                )
            });

            this.map.addControl(new mapboxgl.NavigationControl({showCompass: false}));
        });

        this.map.on('click', 'features', (e) => {
            e.preventDefault();
            if (!e.features) return;
            const feature = e.features[0];
            const coordinates = (feature.geometry as Point).coordinates.slice();

            const activeMarkerElement = document.createElement('div');
            activeMarkerElement.className = 'marker-active';
            activeMarkerElement.innerHTML =
                '<svg width="35" height="51" viewBox="0 0 49 74" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '  <rect x="5" y="29.667" width="39" height="39.3333" fill="white" stroke="white" stroke-width="10"/>' +
                '  <path d="M36.9699 19.6497L12.0301 19.6497L24.5 7.095L36.9699 19.6497Z" fill="white" stroke="white" stroke-width="10"/>' +
                '</svg>'

            const activeMarker = new mapboxgl.Marker(activeMarkerElement).setLngLat([0,0]).addTo(this.map);

            this.popup = new mapboxgl.Popup({
                maxWidth : "100%",
                className: "feature-popup",
                closeButton: true,
                focusAfterOpen: false
            }).setHTML(this.getPopupHtml(feature)).setLngLat([coordinates[0], coordinates[1]]);

            this.popup.on('open', () => {
                const coords = feature.geometry.coordinates;
                activeMarkerElement.classList.add("active");
                activeMarker.setLngLat(coords);
                document.querySelector('#filter-houses').classList.remove("active");
            });

            this.popup.addTo(this.map);

            this.popup.on('close', () => {
                activeMarkerElement.classList.remove("active");
                activeMarker.remove();
            });

        });
    }

    getPopupHtml(feature) {
        const alt = feature.properties.imageAlt ? feature.properties.imageAlt : feature.properties.title;
        return `
            <div class="py-section px-10 md:px-6">
                
                ${feature.properties.image !== undefined ? '<div class="lg:max-w-[270px] max-w-[100%] mix-blend-multiply"><img class="mt-md lg:mt-24 max-h-16 max-w-[100%] md:max-h-28" src="'+feature.properties.image+'" alt="'+alt+'" /></div>' : "<div class=pt-xl></div>"}
                <h4 class="text-xs md:text-sm pb-5">${feature.properties.title}</h4>
                ${feature.properties.info !== undefined ? '<div class="font-body text-base mb-[1.5rem] md:mb-[3.688rem]">' + feature.properties.info + '</div>' : ""}
                <div class="flex justify-center"><a class="oi-button oi-button-small text-center self-end" target="_blank" href="${feature.properties.website}">Zur Webseite</a></div>
            </div>
            `;
    }

    async fetchFeatures() {
        const query = `query Features {
                                  addressEntries {
                                    ... on address_Entry {
                                      id
                                      info
                                      Lat
                                      lang
                                      title
                                      websiteUrl
                                      image {
                                        ... on assets_Asset {
                                          id
                                          alt
                                          url @transform(width: 250, height: 70, mode: "fit")
                                        }
                                      } 
                                      addressCategory {
                                        ... on category_Entry {
                                          id
                                        }
                                      }
                                    }
                                  }
                                }
        `;

        try {
            const response = await fetch(this.apiurl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    query: query,
                })
            });
            const data =  await response.json();

            const features = [];
            data.data.addressEntries.forEach((entry) => {
                {
                    features.push({
                        type: "Feature",
                        id: entry.id,
                        properties: {
                            title: entry.title,
                            info: entry.info,
                            image: entry.image[0]?.url,
                            imageAlt: entry.image[0]?.alt,
                            website: entry.websiteUrl,
                            categories: entry.addressCategory
                        },
                        geometry: {
                            type: "Point",
                            coordinates: [entry.lang, entry.Lat]
                        }
                    })
                }
            });

            return features;
        } catch (error) {
            console.error('There has been a problem with your fetch operation:', error);
        }
    }

    filterList() {
        var input, filter, ul, li, txtValue;
        input = document.getElementById('search-field');
        filter = input.value.toUpperCase();
        ul = document.getElementById("filter-houses-list");
        li = ul.getElementsByTagName('li');

        for (let i = 0; i < li.length; i++) {
            txtValue = li[i].textContent || li[i].innerText;

            let filters = filter.split(" ").filter(f => f.length);

            let shouldDisplay = true;

            filters.forEach(filt => {
                shouldDisplay = shouldDisplay && txtValue.toUpperCase().includes(filt);
            });

            li[i].style.display = (shouldDisplay || filters.length === 0) ? "" : "none";
        }
    }

}
